import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export default function Login() {
  const [params] = useSearchParams();
  const { me, loading } = useAuth();
  const navigate = useNavigate();
  const error = params.get("error");
  const returnTo = params.get("returnTo") || "/";

  useEffect(() => {
    if (!loading && me) navigate(returnTo, { replace: true });
  }, [loading, me, navigate, returnTo]);

  const loginUrl = `/api/auth/login?returnTo=${encodeURIComponent(returnTo)}`;

  return (
    <div style={{ minHeight: "calc(100vh)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div
        data-theme="dark"
        style={{
          maxWidth: 460,
          width: "100%",
          background: "var(--paper)",
          border: "1px solid var(--rule2)",
          padding: "48px 40px",
          textAlign: "center",
        }}
      >
        <img src="/eagle.png" alt="" style={{ height: 72, filter: "var(--logo-filter)", opacity: 0.94, marginBottom: 18 }} />
        <div style={{ fontFamily: "'Cinzel',serif", fontWeight: 900, fontSize: 40, lineHeight: 0.95, letterSpacing: ".02em", color: "var(--ink)" }}>
          VOX IMPERIALIS
        </div>
        <div className="mono" style={{ marginTop: 14, fontSize: 11, textTransform: "uppercase", letterSpacing: ".14em", color: "var(--muted)" }}>
          Coalition Newsletter · Distribution: Imperium Only
        </div>
        <p style={{ color: "var(--ink2)", fontSize: 14, lineHeight: 1.6, marginTop: 24 }}>
          Access is restricted to Imperium members. Sign in with your GICE account to continue.
        </p>
        {error && (
          <div
            className="mono"
            style={{ margin: "16px 0", padding: "10px 12px", fontSize: 11, color: "#fff", background: "var(--accent)", borderRadius: 2 }}
          >
            {error}
          </div>
        )}
        <a href={loginUrl} className="btn btn-accent" style={{ display: "inline-block", marginTop: 12, padding: "12px 22px", fontSize: 12 }}>
          Sign in with GICE →
        </a>
      </div>
    </div>
  );
}
